import { EFeatureMode, IUserFeature } from "./AdvanceFeature";
import { TImageAsset } from "./Asset";
import { IPackage } from "./Package";
import { TAgencySetting, TDomain } from "./Setting";
import { IUserSuspend } from "./suspension";
import { IUserColorTag } from "./ColorTag";
import { EDefaultUserSettingRoute } from "../enums/DefaultUserSetting";

export enum Roles {
  ADMIN = "admin",
  AGENCY = "agency",
  USER = "user",
}

export type IUserData = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  email: string;
  status: string;
  role: Roles;
  firstName: string;
  lastName: string;
  phone: string | null;
  photo: TImageAsset | null;
  photoId: string | null;
  whatsapp: string;
  registrationNumber?: string | null;
  domains: TDomain[];
  company?: string;
  additionalEmail: null | string[];
  googleAdsAccountId?: string | null;
  // measuringId?: null | string;
  headerScript?: string | null;
  bodyScript?: string | null;
  enquiryScript?: string | null;
  config?: TAgencySetting;
  password?: string;
  userFeatures?: IUserFeature[];
  userFeature?: IUserFeature[];
  dynamicLayoutMode?: EFeatureMode;

  agencyLogoId?: string | null;
  agencyLogo?: TImageAsset;
  adRerportUrl?: string | null;
  isFlowSignUp: boolean;
  pricingPlans: string | null;
  statusAccount: "active" | "inactive";
  note?: string;
  userPackage?: IPackage[];
  suspensionDate?: Date;
  reason?: string;
  contactEmail?: string;

  landingPagesCount: number;
  netBalance?: number;

  isAllPackageExpired: boolean;
  userSuspends: IUserSuspend[];
  userColorTags?: IUserColorTag[];
  type?: "ownerUser" | "subUser";
  defaultHomeRoute?: EDefaultUserSettingRoute;
};

export type IUserDataResponse = {
  items: IUserData[];
  total: number;
  totalPage: number;
  currentPage: number;
  limit: number;
};

export type CreateUserDto = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  phone?: string;
  role: Roles;
  additionalEmail?: string[];
  googleAdsAccountId?: string | null;
  // measuringId?: null | string;
  headerScript?: string;
  bodyScript?: string;
  enquiryScript?: string;
  isFlowSignUp?: boolean;
  pricingPlans?: string | null;
  statusAccount?: "active" | "inactive";
  enabledAutoAddNewProject?: boolean;
  note?: string;
  photoId?: string | null;
  defaultHomeRoute?: EDefaultUserSettingRoute | null;
  whatsapp?: string;
  registrationNumber?: string;
};

export type TSetPasswordDto = {
  userId: string;
  password: string;
};

export interface IUserProfileStore extends IUserData {
  isExistPendingPayment?: boolean;
  isVerifying?: boolean;
  isExpiredPackage?: boolean;
}

export interface IUserTimeSlots {
  id: string;
  isAssigned: string;
  timeSlotId: string;
  userId: string;
}

export interface UserXeroPayment {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  userId: string;
  packageId: string;
  adCreditOrderId: string;
  invoiceId: string;
  paymentUrl: string;
  onlineInvoiceUrl: string;
  xeroInvoiceID: string;
  status: string;
  promotionUsageId: string;
  type: string;
  assetId: string;
  method: string;
  reason: string;
  promotionUsage: PromotionUsage;
}

export interface PromotionUsage {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  promotionId: string;
  byUserId: string;
  promotion: Promotion;
}

export interface Promotion {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  code: string;
  description: string;
  discount: string;
  discountType: string;
  status: string;
  startDate: string;
  endDate: string;
}
